import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid'
import FiltersSection from '../../Filters/FiltersSection'
import withStyles from '@material-ui/core/styles/withStyles'
import { Typography } from '@material-ui/core';
import connect from "react-redux/es/connect/connect";
import {getRaspaRecipeUsageStatistics} from "../../../actions/raspaRecipeActions";
import RaspaRecipeCountUsageTable from "./RaspaRecipeCountUsageTable";
import RaspaRecipeRecipeUsageChart from "./RaspaRecipeRecipeUsageChart";
import RaspaCorrectionUsageChart from "./RaspaCorrectionUsageChart";

//const stations = [1,2,3,4]

const styles = theme => ({
  dashboardSection: {
    margin: "5px"
  },
  sectionTitle: {
    marginBottom: theme.spacing(1) * 4,
    marginTop: theme.spacing(1) * 4
  },
    chartGrid: {
        textAlign: 'center',
        marginBottom: "20px"
    }
})

class RaspaRecipeDashboardView extends Component {
    constructor(props) {
        super(props);


        this.onFilterClick = this.onFilterClick.bind(this);

        // if (props.serviceOrderId) {
       // this.props.getProductionStatisticsByStation();
       // this.props.getSOProductionStatistics();
        // }
    }

    componentDidMount(): void {
        this.props.getRaspaRecipeUsageStatistics();
    }

    onFilterClick = () => {
        this.props.getRaspaRecipeUsageStatistics();
    }

    render() {
    const { classes } = this.props;

    return (
      <React.Fragment>
        <Grid container direction="column" className={classes.dashboardSection}>
          <Grid item xs={12}>
            <FiltersSection showPeriod={true} showBeforePeriod={false} showBenchPeriod={false}  onFilterClick={this.onFilterClick}  loading={this.props.loading}/>
          </Grid>
        </Grid>

          <Grid container item direction="row" alignItems="stretch" spacing={16}>
              <Grid item xs={12} className={classes.chartGrid}>
                  <Typography variant="h4" align="center" className={classes.sectionTitle}>
                      Estatísticas de Receitas de uso na Raspa
                  </Typography>
              </Grid>
            {/*<Grid item xs={12} className={classes.chartGrid}>*/}
            {/*    <RaspaRecipeRecipeUsageChart series={this.props.raspaRecipeStatistics.recipeUsage}/>*/}
            {/*</Grid>*/}
              <Grid item xs={12} className={classes.chartGrid}>
                  <RaspaRecipeCountUsageTable series={this.props.raspaRecipeStatistics.countUsage} />
              </Grid>
              {/*<Grid item xs={12} className={classes.chartGrid}>*/}
              {/*    <RaspaCorrectionUsageChart series={this.props.raspaRecipeStatistics.sideCorrectionUsage} />*/}
              {/*</Grid>*/}

          </Grid>

      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
    return {
        raspaRecipeStatistics: state.raspaRecipes.RaspaRecipeStatistics,
        loading: state.raspaRecipes.isFetchingRaspaCycleStatistics
    }
}


export default connect(mapStateToProps, {getRaspaRecipeUsageStatistics} ) (withStyles(styles, {withTheme: true})(RaspaRecipeDashboardView));
